import "./badge.css.js";
const d = {
  badge: "pf-v6-c-badge",
  badgeToggleIcon: "pf-v6-c-badge__toggle-icon",
  modifiers: {
    read: "pf-m-read",
    unread: "pf-m-unread",
    disabled: "pf-m-disabled"
  }
};
export {
  d as default
};
